import React from "react"
import Layout from "../../../components/layout"
import Seo from "../../../components/seo"
import { injectIntl } from "gatsby-plugin-react-intl"
import HeroSubpage from "../../../components/heroes/hero-subpage"
import ClientsTicker from "../../../components/misc/clients-ticker"
import DemoTrial from "../../../components/ctas/demo-trial"
import CapterraTracker from "../../../components/misc/capterra"

const LpThankYouPage = ({ intl, location }) => (
  <Layout>
    <Seo lang={intl.locale} title={intl.formatMessage({id : "pages.lp.thankYou.title"})} description={intl.formatMessage({id : "pages.lp.thankYou.description"})} pathname={location.pathname} />
    <HeroSubpage theme={`primary`} content={{title: intl.formatMessage({id : "pages.lp.thankYou.title"}), text: intl.formatMessage({id : "pages.lp.thankYou.description"})}} />
    <ClientsTicker content={{title: intl.formatMessage({ id: "pages.lp.thankYou.ticker.title" })}}/>
    {/*<DemoTrial />*/}
    <CapterraTracker />
  </Layout>
)

export default injectIntl(LpThankYouPage)

